import { useTranslation } from 'react-i18next'

import { ConfirmDialog } from '~/components/common/ConfirmDialog'
import type { IntradayBulkWithdraw } from '~/pages/IntradayBidding/hooks/useIntradayBulkWithdraw'

type Props = {
  bulkWithdraw: Pick<
    IntradayBulkWithdraw,
    'confirmTargets' | 'isSubmitting' | 'confirm' | 'cancel'
  >
}

/**
 * 入札中の札の一括板取消の確認ダイアログ (AC-BIN-112)。 {N} は開いた時点で固定した対象の件数で、
 * 「取消」 はその札を送る。 送信中は「取消」 を loading にして二重に押させない。
 */
export const IntradayBulkWithdrawConfirmDialog = ({
  bulkWithdraw,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const { confirmTargets, isSubmitting, confirm, cancel } = bulkWithdraw
  return (
    <ConfirmDialog
      body={t('page:biddingIntraday.bulkWithdraw.confirm.body', {
        count: confirmTargets?.length ?? 0,
      })}
      confirmLabel={t('page:biddingIntraday.withdrawConfirm.confirm')}
      destructive
      isLoading={isSubmitting}
      isOpen={confirmTargets !== undefined}
      onCancel={cancel}
      onConfirm={() => {
        void confirm()
      }}
      title={t('page:biddingIntraday.bulkWithdraw.confirm.title')}
    />
  )
}
